let NODE_ENV = window.XINPOC_DISPATCH_CONFIG.isProject;
let title = {
  towway: "two way direct",
  HPYJ: "HPYJ Plataforma de despacho",
  yuantong: "Consola de despacho",
  chunsheng: "Consola de despacho",
  TALK2ME: "Plataforma de despachador web",
  wanlian: "Despachador de intercomunicación CAC",
  EuroNews:"WOUXUN Global",
  quansheng:"QUESUM",
};
let voice_title = {
  XiamenGuanhe:"Plataforma de intercomunicación, servicio dedicado, que hace que la intercomunicación sea más eficiente.",
  wanlian: "Tu seguridad, nuestra obsesión",
}
let conpanyname = {
  chunsheng:"Copyright © 2025 Poclink Radios. All Rights Reserved.",
  XiamenGuanhe:"Glohe Communication Technology(Xiamen) Co.,Ltd.",
  TALK2ME: "Talk2Me Social Inc. (832)880-0000",
  wanlian: "CONGO ASTRAL COMPANY",
  EuroNews: "WOUXUN COMMUNICATIONS LIMITED",
}

let versions = {
  EuroNews:'V1.00.00'
}

module.exports = {
  language: {
    name: 'Inglés',
    title: 'Idioma',
  },

  about: {
    title: title[NODE_ENV] || 'Despachador de Intercomunicación Global',
    conpanyname: conpanyname[NODE_ENV] || 'Schenzhen Broad Información Tecnología Co. LTD.',
    version:versions[NODE_ENV] || "v1.6.2"
  },
  login: {
    account: 'Ingresar Cuenta de Inicio de Sesión',
    password: 'Introducir Contraseña',
    installationServices: 'Instalar servicio de voz',
    rememberme: 'Recuérdame',
    Login: 'Iniciar sesión'
  },
  message: {
    loginAccountTips: 'La cuenta de inicio de sesión no puede estar vacía',
    loginPasswordTips: 'La contraseña contraseña no puede estar en blanco',
    usernamePasswordTips: 'Nombre de usuario o contraseña incorrectos',
    loginsuccessful: 'Inicio de sesión exitoso',
    accountNumbers: 'La cuenta solo puede ingresar números!',
    noDispatcher: 'Error de inicio de sesión, la cuenta no es un despachador.',
    accountNotpresent: 'La cuenta no existe!',
    LoginAbnormal: 'Excepción de inicio de sesión, inténtelo de nuevo.',
    voiceServiceNotInstalled: 'Instala el servicio de voz. Si está instalado, actualice el navegador.',
    Videocallinprogress: 'Videollamada en curso!',
    Voicecallinprogress: '¡En llamada de voz!',
    Youhavebeenclosedforspeaking: 'Se te ha cortado la voz!',
    tctemporarygroup: 'Estas seguro de actualizar y salir del grupo temporal?',
    Doyouwanttologout: 'Quieres cerrar sesión?',
    prompt: 'Sugerencia',
    Nonetworklink: 'Sin conexión a Internet',
    deletedGro: 'Este grupo ha sido eliminado y no se puede utilizar!',
    Pleaseselectthedesired: 'Selección lo que necesitas',
    deletedGroUsers: 'Usuario',
    Voicecallfunction: 'Primero habilite la función de llamada de voz en la plataforma de administración!',
    Alreadytemporary: 'Ya están en un grupo temporal y no puedo llamar!',
    Onlysupports: 'Sólo se emiten llamadas de voz a un sólo usuario!',
    Enablevoicecalls: 'Este usuario, no hay habilitado la función de llamada de voz en la plataforma de administración.',
    Oncall: 'No se puede crear mientras se está en llamada!',
    Shaketodeath: 'No puede crear',
    Shaketodeath2: 'No puede cambiar de grupo',
    createregiongroups: 'Solo puedes crear hasta 3 grupos regionales!',
    temporarygroupsnoadd: 'No se pueden crear grupos temporales!',
    haleDispatcherGroupUser: 'Solo se puede forzar la extracción a los miembros del grupo de desaparecidos',
    TemporaryGroupNoHale: 'No fuerces la extracción de grupos temporales Of, The World World！',
    Groupcallfailure: 'Error en la llamada de grupo',
    Exitsuccessfully: 'Salida exitosa!',
    Usernotonline: 'El usuario está desconectado!',
    Theotherpartyisbusy: 'La otra parte está ocupada!',
    Callfailed: 'Error en la llamada!',
    Theotherpartyhashungup: 'La otra parte ha colgado!',
    Networkconnectionfailed: 'Error en la conexión de red, borre e inténtelo de nuevo más tarde',
    Callended: 'Llamada finalizada!',
    Accountpassworderror: 'Error de contraseña de la cuenta',
    Arrears: 'En mora',
    Accountdoesnotexist: 'La cuenta no existe',
    Permissionerror: 'Error de permiso',
    AccountInfoChange: 'La información de la cuenta ha cambiado',
    Configuration: 'Error en la información de configuración',
    accountOtherlogins: 'La cuenta ya ha iniciado sesión en otra lugar!',
    Accountlogintimeout: 'Tiempo de inicio de sesión de la cuenta agotado',
    Networkconnectionfailure: 'Error de conexión de red',
    Thenetworkisreconnecting: 'La red se está reconectando',
    Addinggroupfailed: 'Error al unirse al grupo',
    Addgrouprequesttimeout: 'Tiempo de espera agotado para la solicitud de unirse al grupo',
    Singlecallfailure: 'Error de llamada única',
    Failedtojointhegroup: 'Error al unirse al grupo (error de permiso)',
    Failedtojointhegroup2: 'Error al unirse al grupo (no existe)',
    Failedtojointhegroup3: 'Error al unirse al grupo (caducado)',
    Failedtojointhegroup4: 'Error a unirse al grupo (límite de cuota)',
    Failedtojointhegroup5: 'Error al unirse al grupo (El objeto válido está vacío)',
    noSnatchingwheat: 'No se permite agarrar trigo varias veces en un corto periodo de tiempo',
    noRemoteclosureSnatchingwheat: 'No se permite agarrar micrófono en estado cerrado remoto',
    Failedtograbthewheat: 'Error al solicitar el enfoque de audio al agarrar micrófono',
    Grabbingwheattimeout: 'Tiempo de espera agotado al recibir la respuesta del micrófono',
    Failedtoopenrecordingdevice: 'Error al abrir el dispositivo de grabación',
    Accountlocked: 'La cuenta está bloqueada',
    Terminallocked: 'El terminal está bloqueado',
    Machinecardlocked: 'La tarjeta está bloqueada',
    Noaccountinformationconfigured: 'No se ha configurado ninguna información de la cuenta',
    Successfullysaved: 'Guardado correctamente!',
    Successfullysethost: 'Configurado anfitrión correctamente!',
    Successfullydeleted: 'Eliminado correctamente!',
    Successfullyadded: 'Añadió correctamente!',
    Successfullyremoved: 'Eliminado correctamente!',
    update_successfully: 'Actualización completeda',
    Successfullymodified: 'Modificado correctamente!',
    oldpassworderror: 'Error de contraseña anterior',
    Parametererror: 'Error de parámetro',
    Pleaseselecttheuseryouwanttoadd: 'Seleccione el usuario que desea agregar!',
    Addingfailed: 'Error al agregar, no está en el grupo. La lista de usuarios está vacía.',
    Pleaseselectuserremoved: 'Seleccione el usuario que desea eliminar!',
    Removalfailed: 'Error al eliminar. La lista de usuarios del grupo está vacía.',
    Prioritysetsuccessfully: 'Prioridad establecida correctamente',
    Pleaseselectastartandendtime: 'Seleccione una hora de inicio y de finalización',
    endTimeNoStarttime: 'La hora de finalización no puede ser anterior a la hora de inicio',
    Thestartandendtimesmustbeonthesameday: 'La hora de inicio y la hora de finalización deben coincidir el mismo dia',
    RedefineCustomization: 'El número de puntos en el área personalizada es inferior a 3. Vuelve a sortear!',
    Unabletocreatetemporarygroup: 'Actualmente no hay miembros en línea, no se puede crear un grupo temporal.',
    Pleaseenteroldpassword: 'Ingresé la contraseña anterior',
    Pleaseenteranewpassword: 'Ingrese una nueva contraseña',
    Confirmnewpassword: 'Confirmar la nueva contraseña',
    noSamePassword: 'La contraseña anterior no puede ser coherente con la nueva contraseña!',
    noSamePasswordTow: 'La contraseña ingresadas dos veces son inconsistentes!',
    pleaseenterpasswordagain: 'Por favor ingrese la contraseña de nuevo',
    Successfullyprocessed: 'Procesado exitosamente',
    voice_title: voice_title[NODE_ENV] || ""
  },
  search: 'Buscar',
  users: 'Usuario',
  refund: 'Regresar',
  Loadingdesperately: 'Cargando desesperadamente',
  Speaking: 'Hablando....',
  Iamspeaking: 'Estoy hablando...',
  communicatebytelephone: 'Conversación de voz',
  call: 'Intercomunicador',
  hale: 'Fuerte tirón',
  Forceddemolition: 'Demolición',
  confirm: 'Seguro',
  cancel: 'Cancelar',
  dispatchIntercom: 'Despachar Inter comunicador',
  allGroups: 'Todos los grupos',
  fixedGroup: 'Grupos fijos',
  regionalGroup: 'Grupo regional',
  filter: 'Filtro',
  all: 'Todo',
  online: 'En línea',
  offline: 'Fuera de',
  groupUser: 'grupo/usuario',
  enter: 'Entrar',
  edit: 'Editar',
  voiceIntercom: 'Intrecomunicador de voz',
  baseStationSwitch: 'Interruptor de estación basal',
  gpsSwitch: 'Interruptor de GPS',
  viewHistoricalTrack: 'Ver historial de recorrido',
  startingtime1: 'Hora de inicio',
  selectionPeriod: 'Seleccionar hora',
  startingTime: 'Hora de inicio',
  Pleaseselectadateandtime: 'Seleccione una hora de inicio',
  EndTime: 'Hora de finalización',
  Pleaseselectanendtime: 'Seleccione una hora de finalización',
  selectDate: 'Seleccionar fecha',
  SelectStartTime: 'Seleccionar hora de inicio',
  Now: 'Ahora',
  Sure: 'Seguro',
  Closure: 'Cierre',
  editArea: 'Área de edición',
  deleteArea: 'Eliminar área',
  Areyousuretosavethefence: 'Está seguro de que desea guardar la valla?',
  deleteLocalgroup: 'Estás seguro de qué desean eliminar el grupo de zonas?',
  pleaseselectaregion: 'Primero rodee con un círculo la área de la barra de selección',
  doubleclicktocreate: 'Haga doble clic para cerrar',
  doubleclick: 'Doble clic',
  Createregionalgroups: 'Crear grupos regionales',
  groupName: 'Nombre del grupo',
  Pleaseenterthegroupname: 'Introduzca un nombre del grupo',
  pleaseenteragroupname: 'Introduzca el nombre de grupo compuesto de 2 a 15 dígitos en en chino o en inglés',
  groupnameTips: 'El nombre del grupo consta de 2 a 15 dígitos en chino o en inglés',
  pleaseenteragroupnameTips: 'Consta de 2 a 15 dígitos en chino e inglés',
  selectGroup: 'Seleccionar grupo',
  Pinnedingroupusers: 'Usuarios anclados en el grupo',
  TemporaryGroup: 'Usuarios temporales en el grupo',
  Usernotingroup: 'Usuario que no está en el grupo',
  userImei: 'Usuario/AMEI',
  Pleaseselectauser: 'Seleccione u usuario',
  Create: 'Crear',
  Cancel: 'Cancelar',
  groupEdit: 'Edición de grupo',
  usersingroup: 'Usuario en el grupo',
  UsernameImei: 'Nombre de usuario/MEI',
  userName: 'Nombre de usuario',
  noData: 'Sin datos',
  removeselectedusers: 'Eliminar usuarios seleccionados',
  Removeall: 'Eliminar todos',
  Addtheselecteduser: 'Añadir usuarios seleccionados',
  Addall: 'Anadir todos',
  Save: 'Guardar',
  selectUser: 'Seleccionar usuario',
  Edittakeseffect: 'La edición surte efecto',
  UserManagement: 'Administración de usuarios',
  Userpriority: 'Prioridad de usuario',
  levelone: 'Nivel uno',
  Secondary: 'Nivel dos',
  Levelthree: 'Nivel tres',
  Levelfour: 'Nivel cuatro',
  Fifthgrade: 'Nivel cinco',
  Editstakeeffectimmediately: 'Las ediciones surte efecto inmediatamente',
  Setmoderator: 'Establecer anfitrión',
  SelectHost: 'Cambiar anfitrión',
  Host: 'Anfitrión',
  Pleasechoose: 'Por favor',
  Deletemoderator: 'Eliminar anfitrión',
  Setuphost: 'Solo se puede configurar un usuario como anfitrión',
  Pleaseselectacall: 'Por favor elija a qué desea llamar?',
  Waitingforanswering: 'Espere a que la otra persona responda la voz',
  Inviteyoutovoicecall: 'Invitar a una llamada de voz',
  callingusers: 'Por favor seleccione el usuario que llamar',
  Forcedpullusers: 'Por favor seleccione el usuario que necesita ser retirado',
  Forceddismantlingusers: 'Por favor seleccione el usuario que necesita ser demolido',
  SearchLocation: 'Buscar ubicación',
  Show: 'Mostrar',
  Hide: 'Ocultar',
  Default: 'Predeterminado',
  Satellite: 'Satélite',
  Roadconditions: 'Condiciones de la carretera',
  Toolbox: 'Caja de herramientas',
  Ranging: 'Alcance',
  Mark: 'Marca',
  Broadcast: 'Transmision',
  EnableBroadcastGroup: 'Por favor habilite al grupo para recibir transmisiones primero',
  textBroadcast: 'Transmision de texto',
  Hasbeensent: 'Ha sido enviado',
  textBroadcastContent: 'Introduzca el contenido de la transmisión de texto (no más de 50 caracteres)',
  pleaseentertextbroadcast: 'Introduzca la transmisión de texto',
  Send: 'Enviar',
  voiceBroadcast: 'Transmisión de voz',
  Clicktorecordvoicebroadcast: 'Haga clic para grabar la transmisión de voz',
  Pleaserecordthevoicebroadcast: 'Grabe la transmisión de voz',
  RecordingTime: 'El tipo de grabación no puede ser inferior a un segundo',
  Broadcaster: 'Eminsor',
  BroadcastTime: 'Hora de transmisión',
  listento: 'Escuchar',
  Warningmessage: 'Mensaje de advertencia',
  AlarmHistory: 'Para obtener más mensajes de advertencia, consulte el historial.',
  Name: 'Nombre',
  Address: 'Dirección',
  Time: 'Hora',
  Check: 'Comprobar',
  State: 'Estado',
  Unprocessed: 'Sin procesar',
  DealWith: 'Tratar con',
  delete: 'Eliminar',
  PTTbuttondisplay: 'Visualización de botón PTT',
  SOSalarmsound: 'Sonido del arma SOS',
  Fencealarmsound: 'Sonido de advertencia de valla',
  Motiontrajectorybinding: 'Vía de movimiento atar camino',
  Changepassword: 'Cambiar contraseña',
  Logoutoflogin: 'Cerrar sesión',
  Dataanalysis: 'Análisis de datos',
  Statisticstoday: 'Estadisticas de hoy',
  Currentonlineusers: 'Usuarios en línea actuales',
  Totalnumberofusers: 'Total de usuarios',
  Fencerecord: 'Registro de la valla',
  SOSrecord: 'SOS record',
  recordingrecord: 'grabación de audio',
  Grouponlineusers: 'Grupo de usuarios en línea',
  Comparison: 'Comparación de número de usuarios en línea en siete días',
  warningcomparison: 'Comparación de alerta temprana de 30 días',
  Fencewarning: 'Advertencia de valla',
  SOSwarning: 'Advertencia de SOS',
  OldPassword: 'Contraseña anterior',
  NewPassword: 'Contraseña nueva',
  ConfirmPassword: 'Confirmar contraseña',
  consists: 'Consta de 6 a 16 letras y números',
  startingpoint: 'Punto de partida',
  totallength: 'Longitud total',
  ico: 'Icono',
  date: 'Fecha',
  Targeting: 'Objetivo',
  Basestationpositioning: 'Posicionamiento de la estación basal',
  BeidouGPS: 'Beidou/GPS',
  direction: 'Dirección',
  altitude: 'Altitud',
  Speed: 'Velocidad (KM/H)',
  warmreminder: 'Recordatorio:Los datos provienen de un tercero y pueden contener errores. Son solo de referencia.',
  Iconselection: 'Selección de icono.',
  pleaseentername: 'Nombre por favor',
  changeicon: 'Cambiar icono',
  Universal: 'Universal',
  policesecurity: 'Seguridad policial',
  Firefighting: 'Bomberos',
  Chemicalindustry: 'Industrial química',
  other: 'Otro',
  save: 'Guardar',
  close: 'Cerrar',
  viewtag: 'Ver etiqueta',
  addtag: 'Añadir etiqueta',
  Supportsaddingamaximum: 'Admite añadir un máximo de 10 iconos',
  Imageformaterror: 'Error de formato de imagen',
  uploadedimage: 'El tamaño de la imagen cargada no puede superar los 5kb.',
  uploadsuccessful: 'Carga exitosa',
  uploadfailed: 'Carga fallida',
  uploadfailedimage: 'Carga fallida: El tamaño máximo de pixeles de la imagen es de 25x25!',
  Successfuloperation: 'Operación exitosa',
  operationfailed: 'Operación fallida',
  Editmark: 'Marca de edición',
  Pleaseselecttheiconyouwanttodelete: 'Seleccione el icono que desea eliminar',
  successfullydeleted: 'Eliminado correctamente',
  failedtodelete: 'No se puede eliminar',
  north: 'Norte',
  South: 'Sur',
  West: 'Oeste',
  East: 'Éste',
  truenorth: 'Norte verdadero',
  duesouth: 'Sur',
  duewest: 'Oeste',
  Zhengdong: 'Zhengdong',
  partial: 'Parcial',
  historyrecord: 'Registro de historial',
  group: 'Grupo',
  pleaseselectagroup: 'Seleccione un grupo',
  sender: 'Remitente',
  Pleaseselectuser: 'Seleccione usuario',
  Sendtime: 'Hora de envío',
  startrange: 'Hora de rango',
  endrange: 'Rango de inicio',
  startdate: 'Rango final',
  Startingtime: 'Hora de inicio',
  enddate: 'Fecha de finalización',
  to: 'A',
  Clear: 'Borra',
  Confirm: 'Confirmar',
  state: 'Estado',
  Pleaseselectastatus: 'Seleccióne un estado',
  Processed: 'Procesado',
  Processor: 'Procesador',
  processtime: 'Tiempo de procesamiento',
  serialnumber: 'Número de serie',
  operate: 'Operar',
  ViewSOSlocation: 'Ver ubicaciones SOS',
  Back: 'Atrás',
  Warmreminder: 'Recordatorio: Los datos provienen de un tercero y puede contener errores. Sólo son de referencia.',
  SOSalarmsintemporarygroupsarenotrecorded: 'Las alarmas SOS en grupos temporales no se registran.',
  Pleaseselectatype: 'Seleccione un tipo',
  deleted: 'Eliminado',
  next: 'Siguiente',
  Tobeprocessed: 'Para ser procesado',
  dealwith: 'Tratar con',
  alreadydispatched: 'Ya enviado',
  temporarygroup: 'Grupo temporal',
  NortheasternHemisphere: 'Hemisferio Noreste',
  northwesternhemisphere: 'Hemisferio Noroeste',
  SoutheasternHemisphere: 'Hemisferio Sureste',
  southwesternhemisphere: 'Hemisferio Suroeste',
  Nolocationtrack: 'Sin seguimiento de ubicación',
  Latitudeandlongitude: 'Latitud y longitud',
  Reportingtime: 'Hora del informe',
  Positioningtime: 'Hora de posicionamiento',
  Alarminformation: 'Información de alarma',
  AlarminformationTips: 'Para obtener más mensajes de alarma consulte los registros del historial',
  initiatesos: 'Iniciar SOS',
  Forcedvideo: 'Video forzado',
  videocall: 'video llamada',
  Videopostback: 'Devolución de video',
  leave: 'Salir',
  Enter: 'Entrar',
  fence: 'Bloquear',
  newgroup: 'Nuevo grupo',
  Joingroup: 'Unirse al grupo',
  Thegroupnamealreadyexistspleasereenterit: 'El nombre del grupo ya existe, por favor vuelve a introducirlo',
  Groupcreatedsuccessfully: 'Grupo creado correctamente',
  Groupcreationfailedpleasecreateagain: 'Error en la creación del grupo por favor créelo de nuevo',
  Pleaseenterthegrouppassword: 'Por favor introduzca la contraseña del grupo',
  Thegrouppasswordyouenterediswrong: 'La contraseña del grupo que ha introducido es incorrecta',
  Grouppassword: 'Contraseña del grupo',
  Dissolve: 'Disolver',
  Exit: 'Salir',
  Disbandselforganizedgroup: 'Disolver el grupo auto organizado',
  Exittheselfcreatedgroup: 'Salir del grupo auto creado',
  ExiDissolvetheselfestablishedgroupt: 'Está seguro de qué desea disolver el grupo auto construido?',
  Exitselfbuiltgroup: 'Está seguro de que desea salir del grupo de autoconstrucción?',
  Grouptransfer: 'Transferencia de grupo',
  Theusersselfbuiltgroupfunctionisnotopened: "La función de grupo auto construido por el usuario no está abierta",
  Createfence: 'Crear valla',
  Editfence: 'Editar valla',
  electricfence: 'Valla eléctrica',
  Electronicfencelist: 'Lista de vallas electrónicas',
  fencename: 'Nombre de valla',
  efficient: 'Eficiente',
  Invalid: 'Inválido',
  Forbidden: 'Prohibido',
  Noentry: 'Sin entrada',
  Pleasesearchorselfselectthefencedareafirst: 'Primero rodee con un círculo el área de la barra de selección',
  Areyousureyouwanttodeletetheelectronicfence: 'Está seguro de que desea eliminar la valla electrónica',
  Triggermode: 'Modo de activación',
  timesetting: 'Adjuste de tiempo',
  Pleaseenterthefencename: 'Introduzca el nombre de la valla',
  tipsItconsists: 'Consta de 1 a 15 caracteres chinos, números, letras y guiones bajos y no puede empezar con un guion bajo',
  tipsItconsistsName: 'El nombre de la valla consta de 1 a 15 caracteres chinos, números, letras y guiones bajos, y no puede empezar con un guion bajo.',
  Pleaseselectamethodofentryandexit: 'Seleccione un método de entrada y salida!',
  Pleaseselectatleastoneday: 'Seleccione al menos un dia',
  Notinfenceusers: 'Usuarios que no están en la valla',
  Usersonthefence: 'Usuarios en la valla',
  Validdate: 'Fecha válida',
  Validperiod: 'Periodo válido',
  Selecttimerange: 'Seleccionar intervalo de tiempo',
  Monday: 'Lunes',
  Tuesday: 'Martes',
  Wednesday: 'Miércoles',
  Thursday: 'Jueves',
  Friday: 'Viernes',
  Saturday: 'Sábado',
  Sunday: 'Domingo',
  Createdsuccessfully: 'Creado correctamente',
  Thefencenameisduplicated: 'El nombre de la valla está duplicado modifíquelo e inténtelo de nuevo.',
  Ifnotselected: 'Si no es selecciona el valor predeterminado es válido de forma permanente',
  FenceEdit: 'Edición de vallas',
  Removalfailedfence: 'Error en la eliminación! La lista de usuarios de la valla está vacía.',
  Failedtoaddfence: 'Error al agregar la lista de usuarios que no está en la valla está vacía.',
  Outofboundsrecord: 'Registro de frontera',
  Outofboundstype: 'Tipo fuera de límites',
  Pleaseselectausername: 'Seleccione un nombre de usuario.',
  Pleaseselecttriggermethod: 'Seleccione el método de activación',
  Crossborderdate: 'Fecha transfronteriza',
  currentrecord: 'Registro actual',
  Triggertime: 'Hora de activación',
  Pleaseselectafencename: 'Seleccione un nombre de valla',
  Releasetime: 'Hora de liberación',
  Batchdownload: 'Descarga por lotes',
  Recordingplayback: 'Reproducción de grabacion',
  download: 'Descarga',
  Areyousureyouwant: 'Está seguro de que desea descargar la grabación seleccionada?',
  Record: 'Grabar',
  Pleaseselecttherecording: 'Seleccione la grabación que desea descargar',
  downloadsuccessful: 'Descargar exitosa',
  Voiceaudio: 'Audio de voz',
  text: 'Texto',
  voice: 'Voz',
  Doubleclicktocreate: 'Haga doble clic para crear',
  Doubleclicktosave: 'Haga doble clic para guardar',
  outofboundsperson: 'Persona fuera de los River',
  temporarygroupTow: 'Grupo temporal',
  Theotherpartyhasnoanswer: 'La otra parte no tiene respuesta.',
  sosrecord: 'S.O.S. record',
  UnhandledSOSexists: 'Existe un SOS sin atender',

  RealTimeVideo: 'Vídeo en vivo',
  ForceVideo: 'Forzar la extracción de vídeo/retorno de vídeo',
  VideoCall: 'Videollamada',
  CurrentlyNoRealTimeVideo: 'Actualmente no hay video en vivo',
  VideoUserList: 'Lista de usuarios de vídeo',
  Filter: 'filtrar: ',
  All: 'todo',
  Online: 'En línea',
  Offline: 'Desconectado',
  GroupUser: 'Grupo/Usuario',
  ForceVideos: 'Vídeo de fuerte tirón',
  PleaseSelectTheUserWhoNeedsxxx: '¡Por favor seleccione un usuario!',
  TheDispatcherCannotForceIt: '¡El despachador no puede forzarlo!',
  VoiceCallInProgress: '¡En llamada de voz!',
  PleaseActivateTheVideoServiceAndVideoCallFunctionOnTheManagementPlatformFirst: '¡Primero active el servicio de video y active la función de videollamada en la plataforma de administración!',
  PleaseEnableTheVideoCallFunctionOnTheManagementPlatformFirst: '¡Primero habilite la función de videollamada en la plataforma de administración!',
  UserIsNotOnline: 'El usuario está desconectado',
  OnlySupportsInitiatingVideoCallsToASingleUser: 'Solo admite iniciar videollamadas a un solo usuario',
  ThisUserHasNotActivatedTheVideoServiceOnTheManagementPlatform: '¡Este usuario no ha activado el servicio de vídeo en la plataforma de gestión!',
  ThisUserHasNotEnabledTheVideoCallFunctionOnTheManagementPlatform: '¡Este usuario no ha habilitado la función de videollamada en la plataforma de gestión!',
  VideoCallInProgress: '¡Videollamada en curso!',
  CannotCallTheTerminalThatIsTransmittingVideo: 'No se puede llamar al terminal que está transmitiendo video',
  TheOtherPartyIsBusy1: 'La otra parte está ocupada',
  ThisUserHasNotEnabledTheForceVideoFunctionOnTheManagementPlatform: '¡Este usuario no ha habilitado la función de vídeo forzado en la plataforma de administración!',
  CannotForceTheTerminalThatIsTransmittingVideo: 'No puedes forzar la extracción del terminal que está cargando el video en ese momento.',
  UserAlreadyExists: 'El usuario ya existe',

  TheOtherPartyInvitedMeToAVideoCall: 'La otra parte te invita a una videollamada...',
  Connecting: 'Conectando...',
  TheOtherPartyHasRejected: 'La otra parte ha rechazado',
  TheOtherPartyHasHungUp: 'La otra parte ha colgado',
  TheOtherPartyDidNotAnswer: 'La persona que llamó no respondió',
  TheOtherPartyIsBusy2: '¡La otra parte está ocupada!',
  ConnectionInterruptedCallEnded: 'La conexión se desconecta, la llamada finaliza!',
  AnswerFailed: 'Respuesta fallida',
  ConnectionFailed: 'La conexión falló',
  exceedFenceMsg:'Se ha superado el número máximo de creaciones. ¡Elimine la valla y vuelva a intentarlo!',

  userPatrol: {
    searchLable: {
        PlanName: "Nombre del proyecto",
        PatrolUsers: "Usuarios de patrulla",
        ExecutionResult: "Resultado de la ejecución",
        PatrolTime: "Tiempo de patrulla",
        PatrolPointName: "Nombres de puntos de patrulla",
    },
    placeholder: {
        PleaseEnterThePlanMame: "Por favor, introduzca el nombre del plan.",
        PleaseEnterThePatrolUser: "Por favor, introduzca el usuario de patrulla.",
        PleaseSelectTheExecutionResult: "Por favor, seleccione el resultado de la ejecución.",
    },
    tableHeader:{
        PlanName: "Nombre del proyecto",
        patrolPoint: "punto de patrulla",
        PatrolUsers: "Usuarios de patrulla",
        PatrolPointName:"Nombres de puntos de patrulla",
        StartTime: "Hora de inicio",
        EndTime: "Hora final",
        ExecutionResult: "Resultado de la ejecución",
        type:"tipo",
        PatrolTime:"Tiempo de patrulla",
    },
    status: {
        NotStarted:"No ha comenzado",
        InProgress: "en curso",
        Completed: "Terminado",
        MissingPatrol: "Inspección perdida",
        positioning: "posición",
        NFC:"NFC",
        Bluetooth: "Bluetooth",
    },
    StartingRange: "Rango inicial",
    EndRange: "Rango final",
    ViewDetails:"Consulta los detalles",
    PatrolTrajectory: "Ruta de patrulla",
    patrol:'Patrulla',
    PatrolFailed:"La patrulla falló",
    PatrolLog: "Registro de patrulla",
  }
};